<template>
  <el-drawer
    :title="$t('mdfeTranslate.compartmentDataCleanup')"
    :visible.sync="searchDrawer"
    :wrapper-closable="false"
    center
    direction="ltr"
    size="900px"
    @closed="handleClosed"
  >
    <div style="padding: 0 20px; height: calc(100vh - 80px); overflow: auto">
      <el-form
        ref="clearingDataRef"
        :model="searchForm"
        class="search-form"
        label-position="top"
        size="small"
      >
        <el-row :gutter="20">
          <el-col :span="10">
            <!--  清理数据截至时间 -->
            <el-form-item
              :label="$t('mdfeTranslate.cleanupDataUntilTime')"
              :rules="{
                required: true,
                message: $t('GlobalSetObj.pleaseChoose'),
                trigger: ['change']
              }"
              prop="operateTime"
            >
              <el-date-picker
                v-model="searchForm.operateTime"
                :placeholder="$t('newOrder.SelectDatetime')"
                style="width: 100%"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <div style="margin-top: 27px">
              <el-button
                size="small" type="primary" @click="enterSearch"
              >{{ $t('mdfeTranslate.clickToCleanup') }}
              </el-button>
              <el-button
                size="small" @click="handleClosed"
              >{{ $t('orderExport.close') }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div v-if="tasksNumber !== -1" style="margin-bottom: 10px">
        <div>{{ $t('mdfeTranslate.taskProgress') }} :</div>
        <div style="margin-top: 10px; display: flex">
          <div style="margin-right: 30px">
            {{ $t('mdfeTranslate.totalTasks') }}: {{ tasksNumber || 0 }}
          </div>
          <div style="display: flex">
            <div style="margin-right: 30px">
              <span><i class="el-icon-success" style="color: #04b553" />
                {{ $t('mdfeTranslate.successfulTasks') }}:
              </span>
              <span>{{ tipData.successCount || 0 }}</span>
            </div>
            <div>
              <span><i class="el-icon-error" style="color: red" />
                {{ $t('mdfeTranslate.failedTasks') }}:
              </span>
              <span>{{ tipData.failCount || 0 }}</span>
            </div>
          </div>
        </div>
      </div>
      <div>{{ $t('mdfeTranslate.selectedData') }}:{{ tableData.length }}</div>
      <el-table
        :data="tableData"
        :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
        border
        style="width: 100%"
      >
        <el-table-column
          :label="$t('GlobalSetObj.serial')"
          align="center"
          prop="index"
          type="index"
          width="60px"
        />
        <el-table-column
          :label="$t('GlobalSetObj.TheNameOfTheDevice')"
          align="center"
          min-width="160px"
          prop="deviceName"
        />
        <el-table-column
          :label="$t('GlobalSetObj.GridSlogan')"
          align="center"
          min-width="130px"
          prop="gridNumber"
        />
      </el-table>
    </div>
  </el-drawer>
</template>

<script>
import { deleteSortedRecord, queryDeleteSortedRecordCount } from '@/api/finance/basicData';

export default {
  data() {
    return {
      searchForm: {
        operateTime: ''
      },
      tableData: [],
      total: 0,
      searchDrawer: false,
      ids: [],
      tasksNumber: -1,
      tipData: {}
      // pickerOptions: {
      //   disabledDate(time) {
      //     // 禁用今天之前的日期
      //     return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
      //   }
      // }
    };
  },
  methods: {
    clearingDataSearch(data) {
      this.searchDrawer = true;
      this.ids = [];
      this.$nextTick(() => {
        this.resetForm();
        this.tableData = data;
      });
      console.log(data, 'data');
      data.forEach((item) => {
        this.ids.push(item.id);
      });
    },
    enterSearch() {
      this.$refs['clearingDataRef'].validate(async(valid) => {
        if (valid) {
          const data = {
            ids: this.ids, // 列表ID
            operateTime: this.searchForm.operateTime
          };
          const res = await queryDeleteSortedRecordCount(data);
          if (res.code === 200) {
            this.tasksNumber = res.data;
          }
          const result = await deleteSortedRecord(data);
          this.tipData = result.data;
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm() {
      this.tasksNumber = -1;
      this.searchForm = {
        operateTime: ''
      };
      this.$refs['clearingDataRef'].resetFields();
    },
    handleClosed() {
      this.searchDrawer = false;
      this.$emit('clearingDataClose');
      this.resetForm();
    }
  }
};
</script>

<style scoped>
.search-form {
  margin-bottom: 20px;
}

.selectLabel .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  border: none;
  font-weight: bold;
  text-align: left;
  padding: 0 !important;
}

>>> .el-form-item {
  margin-bottom: 0 !important;
}
</style>
